import React from 'react';

import config from '../../config';
import { translate as t } from '../../lib/I18n';

import Banner from './Banner';


function BetaBanner () {
    return (
        <Banner className="banner--microsite" bodyClassName="body--banner-microsite">
            <div className="text-center">
                <img src={ config.get('micrositeLogo') } alt={ t('app.owner') } />
            </div>
        </Banner>
    );
}


export default BetaBanner;
